import PageWrapper from '../../components/UI/PageWrapper';
import CustomerDetails from '../../components/Admin/CustomerDetails';

const CustomerDetailsPage = () => (
  <PageWrapper>
    <CustomerDetails />
  </PageWrapper>
);

export default CustomerDetailsPage;
